import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../../../shared/src/lib/service/user.service';
import { AuthenticationService } from '../../../../../shared/src/lib/service/authentification.service';
import { environment } from '../../../../../environments/environment';
import { TeacherService } from '../../../../../shared/src/lib/service/teacher.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { TeacherProfilComponent } from '../../../../../shared/src/lib/feature/teacher-profil/teacher-profil.component';
import { ProfilePhotosService } from '../../../../../shared/src/lib/service/profilePhotos.service';
@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss']
})
export class InformationComponent implements OnInit {
  defaultAvatar = environment.static + '/avatar.png';
  myUser: any;
  myTeacher: any;
  showProfessional = false;
  showReport = false;
  componentToLoad;
  componentName;
  modalParams;
  initialEmail: string;
  currentPassword = '';

  constructor(
    private teacherService: TeacherService,
    private authenticationService: AuthenticationService,
    private deviceService: DeviceDetectorService,
    private userService: UserService,
    private profilePhotosService: ProfilePhotosService
  ) { }

  ngOnInit() {
    // check if desktop vs mobile.
    this.showProfessional = this.deviceService.isDesktop();
    this.showReport = this.deviceService.isDesktop();
    this.myUser = this.authenticationService.getCurrentPersona();
    if (this.myUser) {
      this.initialEmail = this.myUser.user.email;
      this.teacherService.getObservableTeacherByUrl(this.myUser.user.teachers[0])
        .subscribe(_teacher => {
          this.myTeacher = _teacher;
        })
    }
  }

  showModalTeacherProfil() {
    this.componentToLoad = TeacherProfilComponent;
    this.componentName = 'TeacherProfilComponent';
    this.modalParams = { teacher: this.myTeacher, showReviews: true }
  }

  emailChanged(): boolean {
    if (!this.myUser) {
      return false;
    }
    return this.normalizeEmail(this.myUser.user.email) !== this.normalizeEmail(this.initialEmail);
  }

  /**
   * Changer l'email exige le mot de passe actuel (API-R48) : l'email n'est
   * envoyé qu'une fois ce mot de passe saisi.
   */
  updateEmail() {
    if (!this.emailChanged() || !this.currentPassword) {
      return;
    }
    const param = { email: this.myUser.user.email, current_password: this.currentPassword };
    this.userService.patchUser(this.myUser.user.url, param).then(res => {
      if (res) {
        this.initialEmail = this.myUser.user.email;
      }
      this.currentPassword = '';
    });
  }

  private normalizeEmail(email: string): string {
    return (email || '').trim().toLowerCase();
  }

  uploadAvatar($event) {
    for (const file of $event.target.files) {
      this.profilePhotosService.postProfilePhoto(this.myUser.user, file, null).subscribe(photoProfile => {
        this.myUser.user.photo_profile = photoProfile
      })
    }
  }

}
